import ENV from "../../env";
import getAuthHeaders from "../authHeaders";

const createShowroom = async (name) => {
  const headers = await getAuthHeaders();
  
  const response = await fetch(`${ENV.firebaseApiUrl}/showroom/create`, {
    method: "POST",
    headers,
    body: JSON.stringify({
      showroom: { name },
    }),
  });

  const resData = await response.json();

  if (!response.ok) {
    throw new Error("Create Showroom failed: " + resData.message);
  }

  return resData.showroomId;
};

export default createShowroom;
